import '../scss/theme.scss';
import '../scss/splide.min.css';
import { Theme } from './classes/Theme';
import { Pagination } from './modules/Pagination';
import { LazyLoader } from './modules/LazyLoader';
document.addEventListener('DOMContentLoaded', function () {
    var theme = new Theme({
        pagination: new Pagination(),
        lazyLoader: new LazyLoader(),
    });
    theme.load();
    // code for account mobile menu
    var menuButtons = document.querySelectorAll('#menuButton');
    menuButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            var hiddenMenu = button.parentElement.querySelector('#hiddenMenu');
            hiddenMenu.classList.toggle('max-h-0');
            hiddenMenu.classList.toggle('overflow-hidden');
        });
    });
    // code to animate in content while scrolling
    var options = {
        threshold: 0
    };
    var observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting === true) {
                entry.target.classList.add('is-visible');
            }
        });
    }, options);
    var contentToFade = document.querySelectorAll('.fade-in-section');
    contentToFade.forEach(function (target) {
        observer.observe(target);
    });
    var variantSelector = document.querySelector('.variant_selector');
    var variantList = document.querySelector('.variant_dropdown');
    try {
        variantSelector.addEventListener('click', function () {
            variantSelector.classList.toggle('dropdown_active');
            variantList.classList.toggle('hidden');
        });
    }
    catch (e) {
    }
    // code for variant dropdown
});
